// Geet Restaurant Week set menu
export const GEET_SET_MENU_PDF =
  'https://customer-assets-v7afamib.emergentagent.net/job_dbf2a048-f611-4e3a-928e-b07f29ce499b/artifacts/fcw4m52r_GEET%20SET%20MENU%20FINAL%20.pdf';

export const GEET_SET_MENU = [
  {
    name: 'Set Menu One',
    courses: '5-Course Gourmet Menu',
    items: [
      { course: 'Amuse-Bouche', dishes: [{ name: 'Thepla Chicken Tikka Tacos' }] },
      { course: '1st Course', dishes: [{ name: 'Samosa Chaat', desc: 'Panjabi Samosa Chaat — famous dish of Mumbai' }] },
      { course: '2nd Course', dishes: [{ name: 'Mango & Orange Soup', desc: 'with corn crackle and crispy puri' }] },
      { course: '3rd Course', dishes: [{ name: 'Rajuli Kebab', desc: 'Vegetable Samosa & Beet Paneer Bombs' }] },
      { course: '4th Course', dishes: [{ name: 'Coconut Lime Prawn Saffron Rice', desc: 'Mini Saffron Khulcha & Grilled Paneer, topped Grilled Masala Pineapple' }] },
      { course: '5th Course', dishes: [{ name: 'Shrikhand Parle', desc: 'with Mango Gelato' }] },
    ],
  },
  {
    name: 'Set Menu Two',
    courses: '4-Course Gourmet Menu',
    items: [
      { course: 'Amuse-Bouche', dishes: [{ name: 'Street Food of Mumbai', desc: 'Gol Gappa (Pani Puri) · Chicken Tikka Stuffed (3pcs)' }] },
      { course: '2nd Course', dishes: [{ name: 'Samosa Moradabad Dal', desc: 'Cocktail Panjabi Samosa — lentil layered with a spicy fresh cilantro' }] },
      { course: '3rd Course', dishes: [{ name: 'Rogan Chicken', desc: 'Burnt Garlic Rice, Mini Mushroom Khulcha, Grilled Paneer & Grilled Masala Pineapple' }] },
      { course: '4th Course', dishes: [{ name: 'Indian Trio Kulfi Ice Cream', desc: 'Pistachio, Malai & Rose' }] },
    ],
  },
  {
    name: 'Set Menu Three',
    courses: '3-Course Menu',
    items: [
      { course: '1st Course · Starters', dishes: [{ name: 'Butter Chicken Bombs', desc: 'served with Chicken Samosa' }] },
      { course: '2nd Course', dishes: [{ name: 'Chickpea Chicken Masala', desc: 'Lemon Rice, Masala Naan, Grilled Pineapple & Grilled Paneer' }] },
      { course: '3rd Course', dishes: [{ name: 'Chocolate Samosa', desc: 'with Chocolate Ice Cream' }] },
    ],
  },
];
